import { Environment } from './environment';

export const environment: Environment = {
  baseURL: 'https://prodatex-be-dev.zamia.be',
  // baseURL: 'http://localhost:3000',
  daccaBaseURL: 'https://daccaintegration.home-repair.be',
  appInsightsInstrumentationKey: '36db9971-fedd-4288-a2bc-b9d71d3c97d1',
  networkHealthTimeout: 5000,
  maxImageHeight: 1000,
  maxImageWidth: 1080,
  imageQuality: 50,
  oktaAuthorizeUrl: 'https://belfius.okta.com/oauth2/aus7fs4k2plZXAGtC417/v1/authorize',
  oktaClientId: '0oa4tjr7dXZ23GYrm416',
  useOkta: false,
  oktaLogoutUrl: 'https://belfius.okta.com/login/signout'
};
